/* eslint-disable react/prop-types */
import React from 'react';
import { Select } from 'antd';

import { CarOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';

const { Option } = Select;

// Seletor para escolher o operador a ser rastreado
function OperatorSelector({ operators, selectedOperator, onOperatorChange, loading }) {
  const getOperatorIcon = (type) => {
    switch (type) {
      case 'MainInstructor':
        return <UserOutlined />;
      case 'AssistantInstructor':
        return <TeamOutlined />;
      case 'Driver':
        return <CarOutlined />;
      default:
        return <UserOutlined />;
    }
  };

  const handleOperatorChange = (operatorId) => {
    const operator = operators.find((op) => op.id === operatorId);
    if (operator) onOperatorChange(operator);
  };

  return (
    <Select
      value={selectedOperator?.id}
      onChange={handleOperatorChange}
      loading={loading}
      placeholder="Selecione um operador"
      style={{ width: '100%' }}
      disabled={false}
      dropdownStyle={{ borderRadius: '16px' }}
    >
      {operators.map((op) => (
        <Option key={op.id} value={op.id}>
          {getOperatorIcon(op.type)}
          <span style={{ marginLeft: 8 }}>{op.name}</span>
        </Option>
      ))}
    </Select>
  );
}

export default React.memo(OperatorSelector);
